import { z } from 'zod'

export const zodFile = z.instanceof(File).refine((file) => file.size > 0, {
  message: 'form.error.mandatory',
})

export const emptyFile = () => new File([], 'empty.txt')

export const zodDate = z
  .transform((date: Date | string) =>
    date instanceof Date ? date : new Date(date),
  )
  .refine((date) => date.getTime() !== emptyDate().getTime(), {
    message: 'form.error.mandatory',
  })

/** For <input type="date">: form state must be YYYY-MM-DD string so the input displays correctly. */
export const zodDateString = z.union([
  z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, { message: 'form.error.invalidDate' }),
  z.literal(''),
])

export const dateToIsoString = (date: string | Date) =>
  new Date(date).toISOString().split('T')[0]

export const emptyDate = () => new Date('1900-01-01')
